var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ins',{staticClass:"adsbygoogle",style:(_vm.insStyle),attrs:{"data-ad-client":_vm.dataAdClient,"data-ad-slot":_vm.dataAdSlot,"data-ad-format":_vm.dataAdFormat,"data-full-width-responsive":"false"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36636be0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Adsense.vue
// module id = null
// module chunks = 